// removed by extract-text-webpack-plugin
module.exports = {"a-label":"_2I6LpSnSdt6sKBpNvRSBrx","a-label--error":"_30xoG6o2KQhvKG71iGYD52","a-label--checkbox":"_2-XlLvm9j-L8KEkDqbdMUl","a-label--large":"_3-IHnb6mFUZyW9TJbW1cOe","a-label-password":"_2w9LEgKmujVzXLdWuciOL9"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/LabelStyle.scss
// module id = 889
// module chunks = 0